import { useState } from "react";
import type { FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { allCategories } from "@/utils/software";

const mainNav = [
  { label: "首页", to: "/", end: true },
  { label: "全部软件", to: "/softwares", end: false },
  { label: "关于我们", to: "/about", end: false },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [open, setOpen] = useState(false);

  const submitSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
    setOpen(false);
  };

  const linkClass = (isActive: boolean) =>
    `relative rounded-md px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
      isActive ? "text-primary-700" : "text-foreground-700 hover:text-primary-700"
    }`;

  const searchField = (
    <form
      onSubmit={submitSearch}
      className="flex h-10 w-full items-center rounded-md border border-background-300 bg-background-50 pl-3 pr-1 focus-within:border-primary-400 transition-colors"
      role="search"
    >
      <i className="ri-search-line text-base text-foreground-400" aria-hidden="true" />
      <input
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        type="search"
        placeholder="搜索黄金投资软件 / APP"
        aria-label="搜索软件"
        className="h-full flex-1 bg-transparent px-2 text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
      />
      <button type="submit" className="btn-primary h-8 rounded px-3 text-sm">
        搜索
      </button>
    </form>
  );

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="container-page flex h-16 items-center gap-3">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-foreground-950">
            <i className="ri-hand-coin-line" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-sm font-bold text-foreground-900 whitespace-nowrap md:text-base">
              黄金网站软件app免费
            </span>
            <span className="mt-0.5 text-[10px] tracking-wide text-foreground-500">
              GOLD SOFTWARE HUB
            </span>
          </span>
        </Link>

        <nav className="ml-2 hidden items-center lg:flex" aria-label="主导航">
          {mainNav.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => linkClass(isActive)}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-full max-w-xs md:flex">{searchField}</div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-700 cursor-pointer lg:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      <div className="hidden border-t border-background-200 lg:block">
        <div className="container-page flex h-11 items-center gap-1 overflow-x-auto no-scrollbar">
          <Link
            to="/softwares"
            className="flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700 whitespace-nowrap"
          >
            <i className="ri-apps-2-line" />全部软件
          </Link>
          <span className="h-4 w-px bg-background-300" />
          {allCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700 whitespace-nowrap"
            >
              <i className={cat.icon} />
              {cat.name}
            </Link>
          ))}
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="container-page flex flex-col gap-4 py-4">
            {searchField}
            <nav className="flex flex-col" aria-label="移动端导航">
              {mainNav.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${
                      isActive ? "bg-primary-50 text-primary-700" : "text-foreground-700"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
            <div>
              <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-foreground-500">
                软件分类
              </p>
              <div className="grid grid-cols-2 gap-2">
                {allCategories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.id}`}
                    onClick={() => setOpen(false)}
                    className="flex items-center gap-2 rounded-md border border-background-300 px-3 py-2 text-sm text-foreground-700"
                  >
                    <i className={`${cat.icon} text-primary-600`} />
                    {cat.shortName}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}